import React from "react";
import dynamic from "next/dynamic";

const Paragraphs = dynamic(() => import("components/Paragraphs"));

export default function ParagraphGrid({ data, level }) {
  const columns = parseInt(data.field_columns, 10);

  return (
    <>
      {data.field_title && (
        <h2 className="mb-8 font-important font-bold text-xl">
          {data.field_title}
        </h2>
      )}
      <div
        className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-${columns} gap-8`}
      >
        <Paragraphs paragraphs={data.field_paragraphs} level={level + 1} />
      </div>
    </>
  );
}
